import { apiAxiosAuth } from 'services/api';
import { saveObjOnLocalStorage } from 'utils/functions';
import { TokensResp } from 'types/TokensResp';

interface DataLogin {
	email: string;
	password: string;
	type: 'basic' | 'otp';
}

export async function handleLoggin(
	payload: DataLogin,
	setIsLogged: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any,
	t: any
) {
	const resp: { isSuccess: boolean; tokens: TokensResp } = {
		isSuccess: false,
		tokens: { access_token: '', refresh_token: '' }
	};

	await apiAxiosAuth
		.post('auth/login', payload)
		.then(async (res) => {
			resp.isSuccess = true;
			resp.tokens.access_token = res.data?.access_token || '';
			resp.tokens.refresh_token = res.data?.refresh_token || '';
			return;
		})
		.catch((error) => {
			setIsLogged(false);

			handleNotify(
				error?.response?.data?.error || t('login.errorReqLogin'),
				'error'
			);
			resp.isSuccess = false;
			resp.tokens.access_token = '';
			resp.tokens.refresh_token = '';
			return;
		});

	return resp;
}

export async function handleDataUser(
	tokens: TokensResp | null,
	setIsLogged: React.Dispatch<React.SetStateAction<boolean>>,
	handleNotify: any,
	t: any
) {
	let isSuccess = false;
	if (tokens !== null) {
		await apiAxiosAuth
			.get('users/me', {
				headers: { Authorization: `Bearer ${tokens.access_token}` }
			})
			.then((res) => {
				setIsLogged(true);
				saveObjOnLocalStorage(tokens, 'tokensMondelez');
				saveObjOnLocalStorage(res.data, 'userDataMondelez');
				isSuccess = true;
				return;
			})
			.catch((error) => {
				setIsLogged(false);
				handleNotify(
					error?.response?.data?.message || t('login.errorReqLogin'),
					'error'
				);
				isSuccess = false;
				return;
			});
	} else {
		setIsLogged(false);
		handleNotify('Erro no token', 'error');
	}

	return isSuccess;
}
